import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useCoffee } from "../hooks/useCoffees";

export function PrintLabel() {
  const { id } = useParams();
  const numId = Number(id);
  const { data } = useCoffee(Number.isFinite(numId) ? numId : null);
  const [showNotes, setShowNotes] = useState(false);

  useEffect(() => {
    if (data) document.title = `Label — ${data.variety}`;
  }, [data]);

  if (!data) return <p className="p-6 text-paper-600">Loading…</p>;

  const tags = data.flavor_tags.join(", ");
  const grades = data.grade ? data.grade.split(",").map((s) => s.trim()).filter(Boolean) : [];

  return (
    <div className="min-h-screen bg-paper-50">
      <div className="max-w-4xl mx-auto p-6 print:hidden">
        <Link to={`/coffee/${data.id}`} className="text-sm text-paper-600 hover:underline">← Back</Link>
        <div className="flex items-center gap-3 mt-3">
          <button className="btn-primary" onClick={() => window.print()}>Print</button>
          <label className="text-sm flex items-center gap-2">
            <input type="checkbox" checked={showNotes} onChange={(e) => setShowNotes(e.target.checked)} />
            Include personal notes
          </label>
          <span className="text-sm text-paper-600 ml-auto">Sized for Avery 85 × 54 mm</span>
        </div>
      </div>

      <div className="flex justify-center p-6">
        <div
          className="print-area card"
          style={{ width: "85mm", height: "54mm", padding: "4mm", boxSizing: "border-box" }}
        >
          <div className="flex flex-col h-full text-[8pt] leading-snug text-paper-900">
            <div className="flex items-baseline justify-between gap-2">
              <div className="font-display text-[14pt] font-bold leading-none truncate">{data.variety}</div>
              <div className="text-[8pt] text-paper-700 whitespace-nowrap">{data.grams}g</div>
            </div>
            <div className="text-[9pt] text-paper-700 truncate">{data.process}</div>
            <div className="mt-1 truncate"><b>{data.country}</b>{data.region ? ` · ${data.region}` : ""}{data.farm ? ` · ${data.farm}` : ""}</div>
            <div className="truncate">{data.roaster}{data.roaster_city ? ` · ${data.roaster_city}` : ""}</div>
            {data.farmer ? <div className="truncate">Producer: {data.farmer}</div> : null}
            {data.roast_date ? <div>Roasted: {data.roast_date}</div> : null}
            {grades.length > 0 ? (
              <div className="mt-1 flex gap-1">
                {grades.map((g) => (
                  <span key={g} className="border border-amber-700 text-amber-800 px-1 rounded text-[7pt] uppercase font-semibold">{g}</span>
                ))}
              </div>
            ) : null}
            {tags ? <div className="mt-1 italic text-paper-700 truncate">{tags}</div> : null}
            {showNotes && data.personal_notes ? (
              <div className="mt-auto text-[7pt] text-paper-600 truncate">{data.personal_notes}</div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
